/**
 * @file: 计算需要更新的cube
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../cubeTree/index';
import * as Utils from '../utils/util';
// import FindUpdateLayer from './findUpdateLayer';

function findNeedUpdateCubeIds(updateTasks: Array<UpdateTask>): CubeId[] {
    let result: Set<CubeId> = new Set();

    // 先找货架
    updateTasks.forEach((updateTask: UpdateTask): void => {
        if (CubeTree.isShelf(updateTask.cubeId) || CubeTree.isFreezer(updateTask.cubeId)) {
            result.add(updateTask.cubeId);
        }
    });

    // 找层板
    updateTasks.forEach((updateTask: UpdateTask): void => {
        if (!CubeTree.isPartition(updateTask.cubeId)) {
            return;
        }

        // 层板在画布中
        if (CubeTree.isInStage(updateTask.cubeId)) {
            result.add(updateTask.cubeId);
            return;
        }

        let itsShelf: CubeId|null = CubeTree.findCubeShelf(updateTask.cubeId);

        itsShelf && !result.has(itsShelf) && result.add(itsShelf);
    });

    // 找商品、文本框、隔板
    updateTasks.forEach((updateTask: UpdateTask): void => {
        if (!CubeTree.isGoods(updateTask.cubeId)
            && !CubeTree.isTextarea(updateTask.cubeId)
            && !CubeTree.isBafflePlate(updateTask.cubeId)) {
            return;
        }

        // 商品、文本框、隔板在画布中
        if (CubeTree.isInStage(updateTask.cubeId)) {
            result.add(updateTask.cubeId);
            return;
        }

        let itsLayer: CubeId = CubeTree.findCubeLayer(updateTask.cubeId);

        if (CubeTree.isInStage(itsLayer)) {
            result.add(itsLayer);
            return;
        }

        let itsShelf: CubeId|null = CubeTree.findCubeShelf(updateTask.cubeId);

        itsShelf && !result.has(itsShelf) && result.add(itsLayer);
    });

    return Array.from(result);
}

export default findNeedUpdateCubeIds;
